import { removeItem } from "owa-local-storage";
import { PWA_THEME_LOCAL_STORAGE_KEY } from "../const";

export function removeFromStorage(): void {
    removeItem(self, PWA_THEME_LOCAL_STORAGE_KEY);
}
